module.exports = require("react-redux");


/*****************
 ** WEBPACK FOOTER
 ** external "react-redux"
 ** module id = 46
 ** module chunks = 0
 **/